<template>
    <section class="section-module dashboard-module">
        <div class="icon-text-wrapper mb-tablet-only">
            <p @click="showSidebarMenu()" role="button" class="turnback">
                Menu
            </p>
        </div>

        <div class="first-content">
            <h1 class="heading-4">Painel de Controlo</h1>
            <p class="color-text-body">Visão geral dos teus espaços</p>
        </div>

        <div class="second-content-primary">
            <h2 class="heading-6 strong-500">Indicadores de Desempenho</h2>

            <div class="second-content-primary-content-flex">
                <div
                    v-if="Object.values(dashboardData.get_totals).length > 0"
                    class="content-totals"
                >
                    <strong class="body-1 strong-600"
                        >Totais até à data:</strong
                    >

                    <select
                        id="subject"
                        v-model="location"
                        class="form-select"
                        aria-label="Dashboard Location"
                        @change="changeLocation()"
                    >
                        <option
                            v-for="(val, index) in dashboardData.get_totals
                                .locations"
                            :data-referindex="index"
                            :data-key="val.key"
                            :key="val.id"
                            :value="val.id"
                            :selected="val.id === 1 ? true : false"
                            class="body-1"
                        >
                            {{ val.name }}
                        </option>
                    </select>

                    <div class="canva-wrapper">
                        <template
                            v-for="(value, index) in dashboardData.get_totals
                                .locations"
                            :key="index"
                        >
                            <template v-if="parseInt(location) === value.id">
                                <div class="chart-wrapper">
                                    <chart
                                        :labels="
                                            dashboardData.get_totals.offices[
                                                value.key
                                            ].office_name_list
                                        "
                                        :chardata="
                                            dashboardData.get_totals.offices[
                                                value.key
                                            ].total_booking_list
                                        "
                                        :chartoptions="chartOptions"
                                    />
                                </div>
                            </template>
                        </template>
                        
                        <div class="total-info-wrapper">
                            <div class="total-info-span-wrapper">
                                <span class="caption-lg"
                                    >Reservas:

                                    <span
                                        class="color-text-action body-1 strong-600"
                                        >{{
                                            dashboardData.get_totals.totals
                                                .total_booking
                                        }}</span
                                    ></span
                                >
                                <span class="caption-lg"
                                    >Clientes:
                                    <span
                                        class="color-text-action body-1 strong-600"
                                        >{{
                                            dashboardData.get_totals.totals
                                                .total_client
                                        }}
                                    </span></span
                                >
                                <span class="caption-lg"
                                    >Total:
                                    <span
                                        class="color-text-action body-1 strong-600"
                                        >
                                        {{
                                            dashboardData.get_totals.totals.total_order !== null ? 
                                            `${dashboardData.get_totals.totals.total_order} €` : 0
                                        }}
                                    </span></span
                                >
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    v-if="Object.values(dashboardData.get_users).length > 0"
                    class="content-progression-users"
                >
                    <div class="content-progression-users-wrapper">
                        <strong class="body-1 strong-600"
                            >Evolução Mensal de Utilizadores</strong
                        >

                        <div class="progression-bars">
                            <div class="progression-bars-header-titles">
                                <span class="caption-md month color-text-body"
                                    >Mês</span
                                >
                                <span class="caption-md result color-text-body"
                                    >Resultado</span
                                >
                                <span class="caption-md total color-text-body"
                                    >Total</span
                                >
                            </div>

                            <div class="progression-bar-content-flex">
                                <div
                                    v-for="(value, index) in dashboardData
                                        .get_users.months"
                                    :key="index"
                                    :data-month="value.month"
                                    class="progression-bar-item-wrapper"
                                >
                                    <label
                                        class="buttom-body color-text-body"
                                        >{{ value.month_pt_name }}</label
                                    >

                                    <div class="bar-and-count">
                                        <progress
                                            class=""
                                            :value="value.total_month"
                                            :max="
                                                dashboardData.get_users
                                                    .total_users
                                            "
                                        ></progress>

                                        <span class="total-of-month caption-md">
                                            {{ value.total_month }}
                                        </span>

                                        <span
                                            class="caption-md color-text-action total-percentage"
                                            >{{
                                                Math.round(
                                                    (value.total_month /
                                                        dashboardData.get_users
                                                            .total_users) *
                                                        100
                                                )
                                            }}%</span
                                        >

                                        <span
                                            class="total-users caption-md color-white"
                                            >{{
                                                dashboardData.get_users
                                                    .total_users
                                            }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <h2 class="heading-6 strong-500">Atividades Recentes</h2>

        <div class="second-content-secondary">
            <div
                v-if="Object.values(dashboardData.last_users).length > 0"
                class="content-last-users"
            >
                
                <div class="header-last-users">
                    <h3 class="body-1 strong-600">Últimos registros</h3>
                    <a
                        :href="usermodule"
                        target="_self"
                        aria-describedby="Link for show all users"
                        class="color-text-action"
                        >Ver todos</a
                    >
                </div>

                <div class="last-users-figure">
                    <figure
                        v-for="(value, index) in dashboardData.last_users"
                        :key="index"
                        class="last-users-figure-content"
                    >
                        <img :src="value.image" alt="User Image Icon" />

                        <figcaption class="color-text-action button-body">
                            {{ value.name }}
                        </figcaption>
                    </figure>
                </div>
            </div>

            <div
                v-if="Object.values(dashboardData.last_bookings).length > 0"
                class="content-last-booking"
            >
                
                <div class="header-last-users">
                    <h3 class="body-1 strong-600">Próximas reservas</h3>
                    <a
                        :href="managemodule"
                        target="_self"
                        aria-describedby="Link for Manage Booking"
                        class="color-text-action"
                        >Ver todas</a
                    >
                </div>

                <div class="table-scroll-wrapper">
                    
                    <table-element
                        :classname="['table-striped', 'next-bookings-content']"
                    >
                       
                        <template #thead>
                            <tr>
                                <th scope="col" class="first-th">
                                    <p
                                        class="color-text-body strong-600 first-col"
                                        style="border: none; padding-left: 0px"
                                    >
                                        Espaços
                                    </p>
                                </th>
                                <th scope="col">
                                    <p
                                        class="color-text-body border-left strong-400"
                                    >
                                        Reserva
                                    </p>
                                </th>
                                <th scope="col">
                                    <p
                                        class="color-text-body border-left strong-400"
                                    >
                                        Data
                                    </p>
                                </th>
                            </tr>
                        </template>

                       
                        <template #tbody>
                            <tr
                                v-for="(
                                    valbooking, indexbooking
                                ) in dashboardData.last_bookings"
                                :key="indexbooking"
                                :data-referindex="indexbooking"
                            >
                                <td class="first-td">
                                    <div class="border-left-flex-wrapper">
                                        <p class="office-name black">
                                            {{ valbooking.office_name }}
                                        </p>
                                        <p
                                            class="client-name color-text-body caption-md"
                                        >
                                            {{ valbooking.professional_name }}
                                        </p>
                                    </div>
                                </td>
                                <td>
                                    <div class="border-left same-height">
                                        <p class="booking-status">
                                            {{ valbooking.booking_status }}
                                        </p>
                                    </div>
                                </td>
                                <td>
                                    <div
                                        class="border-left border-left-flex-wrapper"
                                    >
                                        <p class="date black">
                                            {{ valbooking.date }}
                                        </p>
                                        <p
                                            class="time color-text-body caption-md"
                                        >
                                            {{
                                                `${valbooking.turndata.begin}:00-${valbooking.turndata.end}:00`
                                            }}
                                        </p>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </table-element>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import ChartElement from "../../elements/ChartElement.vue";
import TableElement from "../../elements/TableElement.vue";
import defaultWebsite from "./../../../defaultWebsiteScript.js";

("use strict");

export default {
    name: "HomeAdmin",
    components: {
        chart: ChartElement,
        tableElement: TableElement,
    },
    props: {
        gettotal: {
            type: String,
            required: true,
        },
        managemodule: {
            type: String,
            required: true,
        },
        usermodule: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        dashboardData: [],
        location: "1",
        chartdata: [],
        changechart: false,

        chartOptions: {
            responsive: true,
            maintainAspectRatio: false,

            layout: {
                padding: 0,
            },

            plugins: {
                legend: {
                    position: "bottom",
                    align: "start",
                    labels: {
                        textAlign: "left",
                        boxWidth: 8,
                        boxHeight: 8,
                        padding: 12,
                        borderRadius: 999,
                        usePointStyle: true,
                        pointStyle: "circle",
                    },
                },
            },
        },
    }),
    created() {
        //Set data
        this.dashboardData = JSON.parse(this.gettotal);

        //Set Default Chart
        this.changeLocation();

        //Get Slice from Last Bookings
        this.dashboardData.last_bookings = this.dashboardData.last_bookings.length > 0 ? this.dashboardData.last_bookings.slice(0, 4) : [];
    },
    mounted() {
        window.addEventListener("DOMContentLoaded", function () {
            defaultWebsite.primaryContentConditional(window.screen.width);
        });
    },
    methods: {
        showSidebarMenu() {
            defaultWebsite.showSidebarMenu();
        },
        changeLocation() {
            return this.location;
        },
    },
    components: {
        chart: ChartElement,
        tableElement: TableElement,
    },
};
</script>
